import { Injectable } from '@angular/core';
import { RestPlantService } from 'src/app/service/rest/plant/rest-plant.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { Device } from '../device/device.model';
import { Tag } from '../utils.model';
import { Plant } from './plant.model';

const plantStorageKey = "UPS-plant";

@Injectable()
export class PlantService {

  private _plant : Plant;
  private _deviceList : Device[] = [];

  constructor(private translate: TranslateFirebaseService,
  private restService : RestPlantService) {
    const data = sessionStorage.getItem(plantStorageKey);
    if (data != null) this.plant = JSON.parse(data);
    else this.plant = new Plant();
  }

  get plant(): Plant {
    return this._plant;
  }

  set plant(plant: Plant) {
    this._plant = plant;
    sessionStorage.setItem(plantStorageKey, JSON.stringify(plant));
  }

  get plantType() : Tag[]{
    const plantTypes = this.translate.getTranslation('enum_plant_type');
    if (plantTypes) {
      return JSON.parse(plantTypes);
    } else {
      return undefined;
    }
  }

  get deviceList() : Device[]{
    return this._deviceList;
  }

  set deviceList(list : Device[]) {
    this._deviceList = list;
  }

  reset(){
    this.plant = new Plant();
    sessionStorage.removeItem(plantStorageKey);
  }

  getPlantById(id: string) {
    return this.restService.getPlant(id);
  }

}
